export default {"src":"/_next/static/media/town.32b3529a.svg","height":89,"width":173,"blurWidth":0,"blurHeight":0};